import React, { useEffect, useState } from 'react';
import { Dialog, Icon } from '@tencent/spaui';
import { getDailyReportDownloadList } from '@/api/operator/cgi/smb/download/index';
import message from '@/utils/message';
import dayjs from 'dayjs';
import { getFromCombinedValue, saveCombinedValue } from '@/utils/storage';
import { FLAGS, REACT_APP_PUBLIC_URL } from '@/constants/Constants';
import { withAccount } from '@/business-components/operator/account-context';
import { User } from '@/model/user';
import { DailyReportDownloadItem } from './model';
import { hasFeatureFlagSuper, hasPurview } from '@/services';

import './index.scoped.less';

const STORAGE_KEY = 'daily_report_notice';
const TODAY = dayjs().format('YYYY-MM-DD');

const DailyReportNotification: React.FC<{ account: User }> = (props) => {
  const { account } = props;
  const [show, setShow] = useState(false);
  const [list, setList] = useState<Array<DailyReportDownloadItem>>([]);

  const getTaskData = () => {
    getDailyReportDownloadList({
      data: {
        start_partition_time: `${TODAY.replace(/-/g, '')}00`,
        end_partition_time: `${TODAY.replace(/-/g, '')}23`,
        page: 1,
        page_size: 20,
      },
    }, false)
      .then((res: any) => {
        const list = res?.data?.list?.filter(({ download_url }: DailyReportDownloadItem) => download_url) || [];
        setList(list);
        if (list.length) {
          setShow(true);
        }
      });
  };

  // 获取当前时间范围(今日8:00至24:00之间)
  const getDateRange = () => {
    const newDate = dayjs();
    const today8 = dayjs().hour(8)
      .minute(0)
      .second(0);
    const tomorrow0 = dayjs().add(1, 'day')
      .hour(0)
      .minute(0)
      .second(0);
    return newDate.isBefore(tomorrow0) && newDate.isAfter(today8);
  };

  useEffect(() => {
    if (!hasPurview(1111) || !hasFeatureFlagSuper('is_daily_report_enable')) {
      return;
    }
    const shouldShow = getFromCombinedValue(FLAGS.WARN_DIALOG_STORAGE_COMBINED_KEY, STORAGE_KEY, { userId: account.user_id }) !== TODAY;
    const range = getDateRange();
    if (shouldShow && range) {
      getTaskData();
    };
  }, []);

  const onClose = () => {
    saveCombinedValue(FLAGS.WARN_DIALOG_STORAGE_COMBINED_KEY, STORAGE_KEY, TODAY, { userId: account.user_id });
    setShow(false);
  };

  const download = (data: DailyReportDownloadItem) => {
    if (!data || !data.download_url) {
      message.strongwarn(`文件 ${data.title} 不存在`);
      return;
    }
    window.open(data.download_url);
  };

  const jump = () => {
    window.open(`${REACT_APP_PUBLIC_URL}/agency/download/dailyreport?params={"report_date":{"start_time":"${TODAY}","end_time":"${TODAY}"}}`);
  };

  const HeaderComponent = (props: any) => {
    const { onClose } = props;
    return (
      <>
        <div className='head-info'><Icon name="info-filled" color="#296BEF" /><h4>日报&时报</h4></div>
        <div className='task-close' onClick={onClose}><Icon type="x-close" boxSize={20} boxGap={8}/></div>
      </>
    );
  };

  const FooterComponent = (props: any) => {
    const { onClose } = props;
    return (
      <>
        <div className='foot-close' onClick={onClose}>全部关闭</div>
        <div className='foot-download' onClick={jump}>查看全部</div>
      </>
    );
  };

  return (
    <Dialog
      animation
      className="daily-report-notice-dialog"
      position="right"
      uncover={true}
      show={show}
      title="日报&时报"
      onClose={onClose}
      onSubmit={onClose}
      onCancel={onClose}
      HeaderComponent={HeaderComponent}
      FooterComponent={FooterComponent}
      hideScrollBar={false}
    >
      <div className='task-list'>
        {
          list.map((v) => {
            const { report_id, partition_time, title } = v;
            return (
              <div className='task-list-item' key={`${report_id}_${partition_time}`}>
                <div className='task-item-name' title={title}>{title}</div>
                <div onClick={() => download(v)} className='task-download'><Icon name="download-outlined"/></div>
              </div>
            );
          })
        }
      </div>
    </Dialog>
  );
};

export default withAccount(DailyReportNotification);
